export default class ArticleBlog {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {}
}
